(function() {
	'use strict';

	angular.module('requestApp').config(stateConfig);

	stateConfig.$inject = [ '$stateProvider', '$urlRouterProvider','GLOBAL_URL' ];

	function stateConfig($stateProvider, $urlRouterProvider,GLOBAL_URL) {
//		$urlRouterProvider.otherwise("/fileTemplate");
		$stateProvider
				.state(
						'fileTemplate',
						{
							url : '/fileTemplate/:productCode/:proposalNum',
							params: {proposalNum: {squash: true, value: null }},
							data : {
								pageTitle : 'Hợp đồng dự thảo'
							},
							views : {
								'content@' : {
									templateUrl : GLOBAL_URL + 'partial?uri=ga/newbusinessform/filetemplate/tabFileTemplate',
									controller : 'FileTemplateControllerAF',
									controllerAs : 'vm'
								}
							}
						})
				.state(
						'fileTemplate.pageOne',
						{
							data : {
								pageTitle : 'Hợp đồng dự thảo'
							},
							views : {
								'partial@fileTemplate' : {
									templateUrl :  GLOBAL_URL + 'partial?uri=ga/newbusinessform/filetemplate/pageOne'
								}
							}
						})
				.state(
						'fileTemplate.pageTwo',
						{
							data : {
								pageTitle : 'Hợp đồng dự thảo'
							},
							views : {
								'partial@fileTemplate' : {
									templateUrl :  GLOBAL_URL + 'partial?uri=ga/newbusinessform/filetemplate/pageTwo'
								}
							}
						})
				.state(
						'fileTemplate.pageFour',
						{
							data : {
								pageTitle : 'Hợp đồng dự thảo'
							},
							views : {
								'partial@fileTemplate' : {
									templateUrl :  GLOBAL_URL + 'partial?uri=ga/newbusinessform/filetemplate/pageFour'
								}
							}
						})
				.state(
						'fileTemplate.pageEight',
						{
							data : {
								pageTitle : 'Hợp đồng dự thảo'
							},
							views : {
								'partial@fileTemplate' : {
									templateUrl :  GLOBAL_URL + 'partial?uri=ga/newbusinessform/filetemplate/pageEight'
								}
							}
						})
				.state(
						'fileTemplate.pageTen',
										{
											data : {
												pageTitle : 'Sản phẩm Liberty'
											},
											views : {
												'partial@fileTemplate' : {
													templateUrl :  GLOBAL_URL + 'partial?uri=ga/newbusinessform/filetemplate/pageTen'
												}
											}
										});
	}
})();
